import { render } from "./AuthHeader.vue?vue&type=template&id=dd552772"
import script from "./AuthHeader.vue?vue&type=script&lang=js"
export * from "./AuthHeader.vue?vue&type=script&lang=js"
script.render = render

export default script